<mat-divider></mat-divider>

<!-- Address Details -->
@if(caisServiceService.hasAnyActiveField(addressColumns)) {
  <mat-list-item class="cais-list-item-title">Address Details</mat-list-item>
  <div class="ui-grid-col-12 container">
    <p-table id="EditFDIDAddressTable" [columns]="addressColumns" [value]="this.caisServiceService.FDIDAddressDetails" class="AddressTable" [resizableColumns]="true" 
      #edit_dt>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          @for(col of columns; track col; let i = $index){
            <col style="min-width: 120px;">
          }
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns let-ri=rowIndex>
        <tr>
          <th id="colActionHeader"></th>
          @for(col of columns; track col; let i = $index){
          <th id="colHeader">
            {{col.header}}
          </th>
        }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-columns="columns" let-addressRowData let-rowIndex="rowIndex">
        <tr [pSelectableRow]="addressRowData" [pSelectableRowIndex]="rowIndex" class="ui-widget-NoUpdated-row">
          @if((this.caisServiceService.FDIDAddressDetails.length === (rowIndex+1))){
            <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="this.caisServiceService.FDIDAddressDetails.push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''});"><em class="pi pi-plus"></em></a></td>
            }
            @if((this.caisServiceService.FDIDAddressDetails.length !== (rowIndex+1))){
            <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="this.caisServiceService.FDIDAddressDetails.splice(rowIndex+1,1);"><em class="pi pi-minus"></em></a></td>
            }
          @for(col of columns; track col; let i = $index){
          <td pEditableColumn class="ui-resizable-column"
            [ngClass]="{'errorFieldBorderBottom':(addressRowData['errorFields'] && addressRowData['errorFields'][col.field]), 'text-center':(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field)), 'text-left':(!['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field))}">
            @if(!['addr_regionCode', 'addr_countryCode'].includes(col.field)){
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [id]="addressRowData[col.field]+'string'" [disabled]="col.disabled" 
                  [(ngModel)]="addressRowData[col.field]" [maxlength]="col.maxlength">
              </ng-template>
              <ng-template pTemplate="output">
                {{addressRowData[col.field]}}
              </ng-template>
            </p-cellEditor>
          }
            <!-- Country & Region Code Menu List -->
            @if(['addr_regionCode', 'addr_countryCode'].includes(col.field)){
            <p-select
              [id]="addressRowData[col.field]+'singleselect'" appendTo="body" [options]="col.dropdownvalue"
              [(ngModel)]="addressRowData[col.field]" [showClear]="true"  [filter]="true" [placeholder]="'Enter Value'" [disabled]="col.disabled"
              class="removeborder maxChoiceWidth" (ngModelChange)="addressRowData['addr_countryCode'] = ((['addr_regionCode'].includes(col.field) && addressRowData['addr_regionCode'] && (!addressRowData['addr_countryCode'] || ['US', 'CA'].includes(addressRowData['addr_countryCode']))) ? addressRowData['addr_regionCode'].slice(0,2) : addressRowData['addr_countryCode'])"
              styleClass="fdid-address-form-dropdown justify-center table-column-dropdown">
            </p-select>
          }
          </td>
        }
        </tr>
      </ng-template>
    </p-table>
  </div>
}
<!-- End of Address Details -->